/* [DV-FLASH 2026-08-07] Exclusive / Opera / Monza — koşullu, süreli EK %10 indirim.
 * Koşullar: aynı ürün en az 2 FARKLI oturumda görüntülendi + sepette + daha önce satın alım yok
 *           + kapsam ürünlerinin sepet toplamı >= 10.000 TL.
 * Zincir: Teklif1 30dk -> kaçarsa 24 saat bekle -> Teklif2 20dk -> kaçarsa 7 gün bekle
 *         -> Teklif3 15dk (SON) -> kaçarsa/opt-out -> kalıcı kapalı.
 * İndirim GERÇEKTİR: Cloudflare Worker, Shopify Admin API ile süresi sunucuda biten
 * tek kullanımlık kod üretir; kod /discount/ ile otomatik uygulanır, kasada düşer.
 */
(function () {
  'use strict';
  if (window.__dvFlashKurulu) return;
  window.__dvFlashKurulu = true;

  // ---------- yapılandırma ----------
  var cfgEl = document.getElementById('dv-flash-cfg');
  var CFG = { worker: '', login: false, orders: 0, pid: null, eligible: false };
  try { if (cfgEl) CFG = JSON.parse(cfgEl.textContent); } catch (e) {}
  if (!CFG.worker) return;

  var ESIK_KURUS = 1000000;        // 10.000 TL
  var MIN_ZIYARET = 2;             // farklı oturum sayısı
  var BEKLE_1 = 24 * 3600 * 1000;  // T1 kaçarsa
  var BEKLE_2 = 7 * 24 * 3600 * 1000; // T2 kaçarsa
  var LS = 'dvFlashV1';
  var SS_SEANS = 'dvFlashSeans';

  // ---------- durum ----------
  function oku() {
    try { return JSON.parse(localStorage.getItem(LS)) || {}; } catch (e) { return {}; }
  }
  function yaz(st) { try { localStorage.setItem(LS, JSON.stringify(st)); } catch (e) {} }
  var st = oku();
  st.elig = st.elig || {};   // bilinen kapsam ürünleri {pid:1}
  st.vis = st.vis || {};     // ziyaretler {pid:{n,s}}
  st.stage = st.stage || 0;  // üretilen teklif sayısı (0-3)
  st.active = st.active || null; // {code, exp, tier}
  st.coolUntil = st.coolUntil || 0;
  st.optOut = !!st.optOut;
  st.done = !!st.done;
  st.hadItems = !!st.hadItems;

  // giriş yapmış ve daha önce sipariş vermiş -> program bu müşteriye hiç çalışmaz
  var eskiMusteri = CFG.login && CFG.orders > 0;

  // ---------- oturum ----------
  var seans = null;
  try {
    seans = sessionStorage.getItem(SS_SEANS);
    if (!seans) {
      seans = 's' + Date.now().toString(36) + Math.random().toString(36).slice(2, 8);
      sessionStorage.setItem(SS_SEANS, seans);
    }
  } catch (e) { seans = 's-tek'; }

  // ---------- ürün ziyaret takibi ----------
  if (CFG.pid && CFG.eligible) {
    var p = String(CFG.pid);
    st.elig[p] = 1;
    var v = st.vis[p] || { n: 0, s: '' };
    if (v.s !== seans) { v.n = (v.n || 0) + 1; v.s = seans; }
    st.vis[p] = v;
    yaz(st);
  }

  // ---------- stil ----------
  var css = '' +
  '#dv-flash-modal{position:fixed;inset:0;z-index:2147483000;display:flex;align-items:center;justify-content:center;padding:16px}' +
  '#dv-flash-modal .dvf-ort{position:absolute;inset:0;background:rgba(10,11,14,.62);backdrop-filter:blur(3px);animation:dvfFade .25s ease}' +
  '#dv-flash-modal .dvf-kart{position:relative;background:#fff;color:#16181d;max-width:420px;width:100%;border-radius:16px;box-shadow:0 24px 64px rgba(0,0,0,.35);padding:28px 24px 22px;text-align:center;animation:dvfPop .3s cubic-bezier(.2,.9,.3,1.2);font-family:inherit}' +
  '#dv-flash-modal .dvf-x{position:absolute;top:10px;right:12px;border:0;background:none;font-size:26px;line-height:1;color:#9aa0aa;cursor:pointer;padding:4px}' +
  '#dv-flash-modal .dvf-x:hover{color:#16181d}' +
  '#dv-flash-modal .dvf-rozet{display:inline-block;background:#16181d;color:#e8c576;font-size:11px;font-weight:700;letter-spacing:.14em;padding:5px 12px;border-radius:999px;margin-bottom:14px}' +
  '#dv-flash-modal h3{font-size:22px;line-height:1.25;margin:0 0 10px;font-weight:700}' +
  '#dv-flash-modal .dvf-mtn{font-size:14.5px;line-height:1.55;color:#3c4250;margin:0 0 16px}' +
  '#dv-flash-modal .dvf-sayac{font-variant-numeric:tabular-nums;font-size:34px;font-weight:800;letter-spacing:.04em;color:#b3261e;margin:2px 0 2px}' +
  '#dv-flash-modal .dvf-sayac-alt{font-size:12px;color:#7a8090;margin-bottom:14px}' +
  '#dv-flash-modal .dvf-kod{background:#faf6ec;border:1px dashed #cfa14f;border-radius:10px;padding:9px 12px;font-size:13.5px;color:#5a4a1e;margin-bottom:16px}' +
  '#dv-flash-modal .dvf-kod b{letter-spacing:.06em}' +
  '#dv-flash-modal .dvf-git{display:block;width:100%;background:#16181d;color:#fff;border:0;border-radius:10px;padding:14px 16px;font-size:15px;font-weight:700;cursor:pointer;text-decoration:none;box-sizing:border-box}' +
  '#dv-flash-modal .dvf-git:hover{background:#000}' +
  '#dv-flash-modal .dvf-sonra{display:block;width:100%;background:none;border:0;color:#7a8090;font-size:13.5px;margin-top:10px;cursor:pointer;padding:6px}' +
  '#dv-flash-modal .dvf-kapat-hep{display:block;width:100%;background:none;border:0;color:#b6bac2;font-size:11.5px;margin-top:4px;cursor:pointer;text-decoration:underline;padding:4px}' +
  '@keyframes dvfFade{from{opacity:0}to{opacity:1}}' +
  '@keyframes dvfPop{from{opacity:0;transform:translateY(14px) scale(.97)}to{opacity:1;transform:none}}' +
  '.dv-flash-banner{display:flex;align-items:center;justify-content:center;gap:8px;background:linear-gradient(90deg,#16181d,#2a2d36);color:#fff;border-radius:10px;padding:10px 14px;margin:10px 12px;font-size:13px;line-height:1.4;text-align:center;flex-wrap:wrap}' +
  '.dv-flash-banner b{color:#e8c576}' +
  '.dv-flash-banner .dvf-b-sayac{font-variant-numeric:tabular-nums;font-weight:800;font-size:15px;color:#ffd98a;letter-spacing:.05em}' +
  '.dv-flash-banner.dvf-doldu{background:#f3f4f6;color:#6b7280}' +
  '#hdt-page-cart .dv-flash-banner{margin:0 0 18px;padding:13px 16px;font-size:14px}' +
  '@media (max-width:560px){#dv-flash-modal .dvf-kart{padding:24px 18px 18px}#dv-flash-modal h3{font-size:19px}#dv-flash-modal .dvf-sayac{font-size:29px}}';
  var stil = document.createElement('style');
  stil.id = 'dv-flash-stil';
  stil.textContent = css;
  document.head.appendChild(stil);

  // ---------- yardımcılar ----------
  function tlFormat(kurus) {
    return (kurus / 100).toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' TL';
  }
  function kalanMs() { return st.active ? st.active.exp - Date.now() : 0; }
  function sayacYazi(ms) {
    if (ms < 0) ms = 0;
    var s = Math.floor(ms / 1000);
    var dk = Math.floor(s / 60);
    var sn = s % 60;
    return (dk < 10 ? '0' : '') + dk + ':' + (sn < 10 ? '0' : '') + sn;
  }

  // ---------- geri sayım ----------
  var tikTimer = null;
  function tikBaslat() {
    if (tikTimer) return;
    tikTimer = setInterval(tik, 1000);
    tik();
  }
  function tik() {
    if (!st.active) { clearInterval(tikTimer); tikTimer = null; return; }
    var ms = kalanMs();
    var yazi = sayacYazi(ms);
    var eller = document.querySelectorAll('[data-dv-flash-count]');
    for (var i = 0; i < eller.length; i++) eller[i].textContent = yazi;
    if (ms <= 0) sureDoldu();
  }

  function sureDoldu() {
    var tier = st.active ? st.active.tier : st.stage;
    st.active = null;
    st.hadItems = false;
    if (tier >= 3) { st.done = true; }
    else if (tier === 2) { st.coolUntil = Date.now() + BEKLE_2; }
    else { st.coolUntil = Date.now() + BEKLE_1; }
    yaz(st);
    clearInterval(tikTimer); tikTimer = null;
    modalKapat();
    bannerlariDolduYap();
  }

  // ---------- banner ----------
  function bannerHtml() {
    return '<span>⏳</span><span><b>EK %10 indirim aktif</b> — kasada tüm indirimlere ek olarak otomatik uygulanır</span>' +
      '<span class="dvf-b-sayac" data-dv-flash-count>' + sayacYazi(kalanMs()) + '</span>';
  }
  function bannerEkle() {
    if (!st.active) return;
    // 1) Sepet çekmecesi
    var drawer = document.querySelector('#CartDrawer .hdt-mini-cart__wrap');
    if (drawer && !drawer.querySelector('.dv-flash-banner')) {
      var b1 = document.createElement('div');
      b1.className = 'dv-flash-banner';
      b1.innerHTML = bannerHtml();
      drawer.insertBefore(b1, drawer.firstChild);
    }
    // 2) Sepet sayfası
    var sayfa = document.querySelector('#hdt-page-cart .hdt-page-cart__wrap');
    if (sayfa && !sayfa.parentNode.querySelector('.dv-flash-banner')) {
      var b2 = document.createElement('div');
      b2.className = 'dv-flash-banner';
      b2.innerHTML = bannerHtml();
      sayfa.parentNode.insertBefore(b2, sayfa);
    }
    tikBaslat();
  }
  function bannerlariDolduYap() {
    var bs = document.querySelectorAll('.dv-flash-banner');
    for (var i = 0; i < bs.length; i++) {
      bs[i].className = 'dv-flash-banner dvf-doldu';
      bs[i].innerHTML = '<span>⌛</span><span>Ek %10 indirimin süresi doldu — indirim kapandı.</span>';
    }
  }

  // DOM yeniden çizimlerinde banner'ı geri koy (drawer section-render ile yenilenir)
  var moZaman = 0;
  var mo = new MutationObserver(function () {
    if (!st.active) return;
    var simdi = Date.now();
    if (simdi - moZaman < 400) return;
    moZaman = simdi;
    setTimeout(bannerEkle, 60);
  });
  try { mo.observe(document.body, { childList: true, subtree: true }); } catch (e) {}

  // ---------- modal ----------
  function modalKapat() {
    var m = document.getElementById('dv-flash-modal');
    if (m) m.remove();
  }
  function modalGoster(tier) {
    if (document.getElementById('dv-flash-modal')) return;
    var basliklar = {
      1: 'Size Özel Bir Ayrıcalık',
      2: 'Size Bir Şans Daha Tanıdık',
      3: 'Son Kez: Size Özel EK %10'
    };
    var metinler = {
      1: 'Beğendiğinizi düşündüğümüz sepetinizdeki seçili ürünler için <b>tüm indirimlere EK %10</b> indirim tanımladık. Bu fırsat yalnızca aşağıdaki süre boyunca geçerli.',
      2: 'Geçen sefer süre dolmuştu. Sepetinizdeki seçili ürünler için <b>EK %10</b> indirimi sizin için <b>bir kez daha</b> tanımladık.',
      3: 'Bu, sizin için tanımladığımız <b>son</b> EK %10 indirim. Süre dolduğunda bu teklif bir daha sunulmayacak.'
    };
    var m = document.createElement('div');
    m.id = 'dv-flash-modal';
    m.innerHTML =
      '<div class="dvf-ort"></div>' +
      '<div class="dvf-kart" role="dialog" aria-modal="true" aria-label="Size özel indirim">' +
        '<button class="dvf-x" aria-label="Kapat">×</button>' +
        '<span class="dvf-rozet">SİZE ÖZEL</span>' +
        '<h3>' + basliklar[tier] + '</h3>' +
        '<p class="dvf-mtn">' + metinler[tier] + '</p>' +
        '<div class="dvf-sayac" data-dv-flash-count>' + sayacYazi(kalanMs()) + '</div>' +
        '<div class="dvf-sayac-alt">süre sonunda indirim otomatik kapanır</div>' +
        '<div class="dvf-kod">Kodunuz uygulandı: <b>' + st.active.code + '</b><br>Ödeme sayfasında ek %10 otomatik düşer.</div>' +
        '<a class="dvf-git" href="/cart">Sepete Git</a>' +
        '<button class="dvf-sonra">Şimdi değil</button>' +
        '<button class="dvf-kapat-hep">Bu teklifleri bir daha gösterme</button>' +
      '</div>';
    document.body.appendChild(m);
    m.querySelector('.dvf-x').addEventListener('click', modalKapat);
    m.querySelector('.dvf-sonra').addEventListener('click', modalKapat);
    m.querySelector('.dvf-ort').addEventListener('click', modalKapat);
    m.querySelector('.dvf-kapat-hep').addEventListener('click', function () {
      st.optOut = true; yaz(st); modalKapat();
    });
    tikBaslat();
  }

  // ---------- sepet değerlendirme ----------
  var degerlendiriliyor = false;
  function degerlendir() {
    if (degerlendiriliyor) return;
    if (eskiMusteri || st.optOut || st.done) return;

    degerlendiriliyor = true;
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (sepet) {
        degerlendiriliyor = false;
        if (!sepet || !sepet.items) return;

        // satın alma sezgisi: aktif teklif varken dolu sepet tamamen boşaldıysa
        // (büyük olasılıkla sipariş verildi) -> program kalıcı kapanır
        if (st.active && st.hadItems && sepet.item_count === 0) {
          st.done = true; st.active = null; yaz(st);
          clearInterval(tikTimer); tikTimer = null;
          return;
        }
        if (st.active) {
          if (sepet.item_count > 0) { st.hadItems = true; yaz(st); }
          bannerEkle();
          return; // aktif teklif varken yenisi üretilmez
        }
        if (st.stage >= 3) { st.done = true; yaz(st); return; }
        if (Date.now() < st.coolUntil) return;

        var toplam = 0, ziyaretTamam = false;
        for (var i = 0; i < sepet.items.length; i++) {
          var it = sepet.items[i];
          var pid = String(it.product_id);
          if (st.elig[pid]) {
            toplam += it.final_line_price;
            var v = st.vis[pid];
            if (v && v.n >= MIN_ZIYARET) ziyaretTamam = true;
          }
        }
        if (toplam >= ESIK_KURUS && ziyaretTamam) teklifUret();
      })
      .catch(function () { degerlendiriliyor = false; });
  }

  var uretiliyor = false;
  function teklifUret() {
    if (uretiliyor) return;
    // çok sekmeli koruma
    try {
      var kilit = parseInt(localStorage.getItem('dvFlashKilit') || '0', 10);
      if (Date.now() - kilit < 15000) return;
      localStorage.setItem('dvFlashKilit', String(Date.now()));
    } catch (e) {}
    uretiliyor = true;
    var tier = st.stage + 1;
    fetch(CFG.worker + '/issue', {
      method: 'POST',
      headers: { 'content-type': 'application/json' },
      body: JSON.stringify({ tier: tier })
    })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        uretiliyor = false;
        if (!d || !d.ok || !d.code) return;
        st.stage = tier;
        st.active = { code: d.code, exp: d.expiresAt, tier: tier };
        st.hadItems = true;
        yaz(st);
        // kodu sepete uygula (checkout'ta otomatik düşer)
        fetch('/discount/' + encodeURIComponent(d.code), { credentials: 'same-origin' })
          .catch(function () {});
        bannerEkle();
        modalGoster(tier);
      })
      .catch(function () { uretiliyor = false; });
  }

  // ---------- tetikleyiciler ----------
  // sepete ekleme / değişiklik isteklerinden sonra yeniden değerlendir
  var esasFetch = window.fetch;
  window.fetch = function () {
    var url = (arguments[0] && arguments[0].url) || String(arguments[0] || '');
    var soz = esasFetch.apply(this, arguments);
    if (/\/cart\/(add|change|update)/.test(url)) {
      soz.then(function () { setTimeout(degerlendir, 900); }).catch(function () {});
    }
    return soz;
  };

  function basla() {
    if (st.active) {
      if (Date.now() >= st.active.exp) { sureDoldu(); }
      else { bannerEkle(); tikBaslat(); }
    }
    degerlendir();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', basla);
  } else { basla(); }

  // sepet sayfasında görünürken periyodik kontrol (yavaş, sıkmayan)
  setInterval(function () {
    if (document.hidden) return;
    if (st.active) return;
    if (location.pathname === '/cart' || document.querySelector('#CartDrawer:not(.hdt-hidden)')) degerlendir();
  }, 30000);
})();
